import { render, staticRenderFns } from "./OriginGroupsForm.vue?vue&type=template&id=90bf48ba&scoped=true&"
import script from "./OriginGroupsForm.vue?vue&type=script&lang=js&"
export * from "./OriginGroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./OriginGroupsForm.vue?vue&type=style&index=0&id=90bf48ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bf48ba",
  null
  
)

export default component.exports